import React from 'react'
import './family-info-quick-display.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { differenceInDays, startOfDay } from 'date-fns'

const FamilyInfoQuickDisplay = ({quickDisplay}) => {
    const [onboardDate, setOnboardDate] = React.useState('')

    React.useEffect(() => {
        if(quickDisplay.familyId === 'none' || !quickDisplay.familyId) {

        } else {
            axios.get(`${baseUrl}/school-management/${quickDisplay.familyId}`).then((res) => {
                setOnboardDate(res.data.onboardDate)
            })
            .catch((err) => console.log(err))
        }
    })

    const calculateHowLongOnboardingIsTaking = (date) => {
        return differenceInDays(new Date(), startOfDay(new Date(date)))
    }

    const findNextTask = () => {
        let found = null;
        quickDisplay.todoSubtasks.forEach((subtask) => {
          if (!subtask.subtaskCompleted && !found) {
            found = subtask.subtaskName;
          }
        });
        if (!found) {
          found = quickDisplay.todoSubtasks[0].subtaskName;
        }
        return found;
      };
      

    return(
        <div className='quick-display__popup-box'>
            {onboardDate && <div className='quick-display__time-to-onboard'>Time to onboard: {calculateHowLongOnboardingIsTaking(onboardDate)} days</div>}
        <div className='quick-display__family-name'>{quickDisplay.todoName}</div>
        {quickDisplay.studentList.map((stu) => (
            <div key={stu.studentId} className='quick-display__instrument__wrapper'>
                {stu.instrumentList.map((inst) => (
                    <div key={inst.id} className='quick-display__instrument__each-inst'>{inst.name}</div>
                ))}
            </div>
        ))}
        {quickDisplay.studentList.map((stu) => (
            <div key={stu.studentId} className='quick-display__student__wrapper'>
                <div className='quick-display__student__student-name'>{stu.studentName}</div>
                <div className='quick-display__student__instrument-wrapper'>
                    {stu.instrumentList.map((inst) => (
                        <div key={inst.id} className='quick-display__student__instrument-name'>{inst.name}</div>
                    ))}
                </div>
                <div className='quick-display__student__teacher-wrapper'>
                    {stu.teacherList.map((teach) => (
                        <div key={teach.TeacherID} className='quick-display__student__teacher-name'>{teach.Name.split(' ')[0]}</div>
                    ))}
                </div>
                {stu.introLesson.date && <div className='quick-display__student__teacher-lesson-date'>{`${new Date(stu.introLesson.date).getMonth() + 1}/${new Date(stu.introLesson.date).getDate()}`}</div>}
                {stu.introLesson.hasBeenCalled && <img src='./right.svg' alt='right arrow svg' className='quick-display__student__has-been-called'/>}
            </div>
        ))}
        <div className='quick-display__next-task'><strong>Next Task: </strong>{findNextTask()}</div>
    </div>
    )
}
export default FamilyInfoQuickDisplay